// extracted by mini-css-extract-plugin
module.exports = {"title":"LightTitledContent_title__3HwRw"};